import { Pipe, PipeTransform } from '@angular/core';

import { DateTime } from 'luxon';

@Pipe({
    name: 'relativeTime'
})
export class RelativeTimePipe implements PipeTransform {
    //Returns a string of how long ago the inputted time is relative to now
    transform(value: string): string | null {
        if (!value) return null;
        const base = DateTime.fromISO(value);
        return base.toRelative({ style: 'short' });
    }
}
